import script from "./FileUploadSuccessComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadSuccessComponent.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadSuccessComponent.vue?vue&type=style&index=0&id=0a495032&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a495032"]])

export default __exports__